/**
 * @generated SignedSource<<575aa0ac902f70ccf49448d3df147e43>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionDetail_VersionDetailInner_devOps$data = {
  readonly providers?: {
    readonly designProviders: ReadonlyArray<{
      readonly __typename: "DevOpsDesignProvider";
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps";
};
export type ui_softwareReleasesVersionDetail_VersionDetailInner_devOps$key = {
  readonly " $data"?: ui_softwareReleasesVersionDetail_VersionDetailInner_devOps$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetail_VersionDetailInner_devOps">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudAri"
    },
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    }
  ],
  "kind": "Fragment",
  "name": "ui_softwareReleasesVersionDetail_VersionDetailInner_devOps",
  "selections": [
    {
      "condition": "isDevopsFeatureDisabledInFedRamp",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "cloudAri"
            },
            {
              "kind": "Literal",
              "name": "providerTypes",
              "value": [
                "DESIGN"
              ]
            }
          ],
          "concreteType": "DevOpsProviders",
          "kind": "LinkedField",
          "name": "providers",
          "plural": false,
          "selections": [
            {
              "concreteType": "DevOpsDesignProvider",
              "kind": "LinkedField",
              "name": "designProviders",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "DevOps"
};

(node as any).hash = "72d5936bbd25e3ba21b829d9fbc1ac05";

export default node;
